import axios from 'axios';
import { isLoggedIn } from '../auth';

/**
* Fetches all available skillsets
* @returns {Promise} response - a promise of skillsets to be resolved
*/
export function getSkillsets() {
	if (isLoggedIn()) {
		return axios.get('/v1/skillsets');
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
* creates skillsets for a user
* @param {Number} id - id of user
* @param {Object} data - an object containing an array of selected skillsets id
* @returns {Promise} response -a promise of skillsets to be created
*/
export function postSkillsets(id, data) {
	if (isLoggedIn()) {
		return axios.post(`/v1/users/${id}/skillsets`, data);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
* Gets skillsets of a user
* @param {Object} id - id of user
* @returns {Promise} response - a promise of user skillsets
*/
export function getUserSkillsets(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/users/${id}/skillsets`);
	}
	return Promise.resolve(new Response(
		{ 
			message: 'Unauthorised' 
		},
		{
			status: 403,
			statusText: 'Unauthorised'
		}
	));
}
